/* eslint-disable camelcase */
export default function getReferer(url, refererSource, isServer) {
  let utm_medium = "";
  let utm_campaign = "";
  let source = "";
  let queryString = "";
  let origin = "";
  let documentReferrer = "";
  const hostname = isServer ? "" : window?.location?.hostname;

  const utmSourceKey = `${hostname}_utm_source`;
  const utmMediumKey = `${hostname}_utm_medium`;
  const utmCampaignKey = `${hostname}_utm_campaign`;

  if (isServer) {
    queryString = url ? url.split("?")[1] : "";
    origin = refererSource ? refererSource.split("?")[0] : "";
  } else {
    queryString = window.location.search;
    origin = window.location.origin;
    documentReferrer = document.referrer;

    if (
      refererSource === "Internal Candidate" ||
      refererSource === "Internal%20Candidate"
    ) {
      sessionStorage.setItem(utmSourceKey, "Internal Candidate");
    } else {
      const storedSource = sessionStorage.getItem(utmSourceKey);
      if (storedSource) {
        source = storedSource;
      }
    }
  }

  const urlParams = new URLSearchParams(queryString);
  utm_campaign =
    urlParams.get("utm_campaign") || urlParams.get("campaign") || utm_campaign;
  utm_medium =
    urlParams.get("utm_medium") || urlParams.get("medium") || utm_medium;
  source =
    source ||
    urlParams.get("utm_source") ||
    urlParams.get("source") ||
    refererSource;

  if (!isServer) {
    utm_medium = sessionStorage.getItem(utmMediumKey) || utm_medium;
    utm_campaign = sessionStorage.getItem(utmCampaignKey) || utm_campaign;
    source = sessionStorage.getItem(utmSourceKey) || source;

    if (!sessionStorage.getItem(utmMediumKey) && utm_medium) {
      sessionStorage.setItem(utmMediumKey, utm_medium);
    }
    if (!sessionStorage.getItem(utmCampaignKey) && utm_campaign) {
      sessionStorage.setItem(utmCampaignKey, utm_campaign);
    }
    if (!sessionStorage.getItem(utmSourceKey) && source) {
      sessionStorage.setItem(utmSourceKey, source);
    }
  }

  const isFromExternal =
    documentReferrer && documentReferrer.indexOf(origin) === -1;

  if (
    !isFromExternal &&
    !utm_medium &&
    !utm_campaign &&
    (!source || source === "undefined")
  ) {
    return {
      utm_source: "Direct",
    };
  }

  const data = {};
  if (utm_campaign) data.utm_campaign = utm_campaign;
  if (utm_medium) data.utm_medium = utm_medium;

  data.utm_source = source && source !== "undefined" ? source : "Direct";

  return data;
}
